.wrap {
  display: flex;
  align-items: center;
  gap: 2px;
}

.btn {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease;
}

.btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.slider {
  width: 0;
  overflow: hidden;
  transition: width 0.18s ease;
  display: flex;
  align-items: center;
}

.slider.open {
  width: 76px;
}

.slider input[type='range'] {
  width: 68px;
  accent-color: #e11d2e;
  cursor: pointer;
}
